import MainContentKorean from 'components/ScienceFiguresKorean/MainContent';
import Head from 'next/head';

export default function ScienceFiguresKoreanPage() {
  return (
    <>
      <Head>
        <title> 세계 최대 규모의 과학 일러스트 갤러리 – Mind The Graph</title>

        <meta
          name="description"
          content=" 80개 이상의 연구분야 및 75,000개 이상의 과학 일러스트로 연구를 시각적으로 전달해 보세요."
        />

        <meta
          name="keywords"
          content="그래픽초록, 연구초록, 연구일러스트, 과학포스터, 연구인포그래픽, 무료연구템플릿, 학술디자인도구, Research Figure, infographics, graphical abstracts"
        />
      </Head>

      <MainContentKorean />
    </>
  );
}
